import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { BadgeComponent } from '../../ui/badge/badge.component';
import { BadgeColor } from '../../ui/badge/badge.component';
import { FormsModule } from '@angular/forms';

// Exporting columns for dynamic data 
export interface TableColumn {
  header: string;
  field: string;
  type: string;
  cellTemplate?: TemplateRef<any>;
}

@Component({
  selector: 'app-data-table',
  standalone: true,
  imports: [CommonModule, BadgeComponent, CommonModule, FormsModule],
  templateUrl: './data-table.component.html',
})



export class DataTableComponent implements OnChanges {

  @Input() title: string = '';
  @Input() columns: any[] = [];
  @Input() data: any[] = [];
  @Input() pageSize: number = 5;

  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  currentPage = 1;
  totalPages = 1;
  currentItems: any[] = [];

  searchTerm = '';
  sortField: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  filteredData: any[] = [];

  ngOnChanges(): void {
    this.applyFilters();
  }

  applyFilters() {
    let temp = [...this.data];

    // Global Search
    if (this.searchTerm) {
      temp = temp.filter(item =>
        Object.values(item).some(val =>
          String(val).toLowerCase().includes(this.searchTerm.toLowerCase())
        )
      );
    }

    // Sorting
    if (this.sortField) {
      temp.sort((a, b) => {
        const aVal = a[this.sortField];
        const bVal = b[this.sortField];

        if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1;
        if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1;
        return 0;
      });
    }

    this.filteredData = temp;
    this.totalPages = Math.ceil(this.filteredData.length / this.pageSize);
    this.currentPage = 1;
    this.updateItems();
  }

  updateItems() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.currentItems = this.filteredData.slice(start, end);
  }

  sort(column: any) {
    if (!column.sortable) return;

    if (this.sortField === column.field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = column.field;
      this.sortDirection = 'asc';
    }

    this.applyFilters();
  }

  setupPagination() {
    this.totalPages = Math.ceil(this.data.length / this.pageSize);
    this.currentPage = 1;
    this.updateItems();
  }

  // updateItems() {
  //   const start = (this.currentPage - 1) * this.pageSize;
  //   const end = start + this.pageSize;
  //   this.currentItems = this.data.slice(start, end);
  // }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.updateItems();
  }

 getBadgeColor(value: string): BadgeColor {
  switch (value) {
    case 'Active':
    case 'Approved':
      return 'success';

    case 'Pending':
      return 'warning';

    case 'Suspended':
    case 'Rejected':
    case 'Inactive':
      return 'warning';

    default:
      return 'light';
  }
}
}